import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { TimetablePersonsTable } from '../../../../components/Persons/Tables/TimetablePersonsTable';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { PersonRole } from '../../../../types/planung-graphql-client-defs';

export const SetupPersons = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <TabBar
        variant={'large'}
        tabs={[
          {
            trigger: t('persons.title', { count: 2 }),
            id: 'teachers',
            content: <TimetablePersonsTable personsRole={PersonRole.Teacher} />,
          },
          {
            trigger: t('persons.other'),
            id: 'other',
            content: <TimetablePersonsTable personsRole={PersonRole.Other} />,
          },
        ]}
      />
    </Page>
  );
};
